import { useMutation } from '@tanstack/react-query';
import { repo } from 'index';

export const useEnterpriseLicensePlateTaxIdNumberUpdate = () => {
  const { mutateAsync, status, isLoading, error } = useMutation({
    mutationFn: repo.updateEnterpriseLicensePlateTaxIdNumber,
  });

  return {
    updateEnterpriseLicensePlateTaxIdNumberMutateError: error,
    updateEnterpriseLicensePlateTaxIdNumberMutateAsync: mutateAsync,
    updateEnterpriseLicensePlateTaxIdNumberStatus: status,
    isEnterpriseLicensePlateTaxIdNumberUpdateLoading: isLoading,
  };
};
